import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import { Row,Col, Card, Form, Button, } from 'react-bootstrap';
import {Helmet} from "react-helmet";
import {
  getls, integerIndMobile, lettersOnly, integerAadhar, integerKeyPress, decimalKeyPress, upperCase
} from '../../../utils';
import {Api} from '../../../utils/Variables';
import axios from 'axios';
import { Spin } from 'antd';

import PsContext from '../../context/PsContext';
import TsValue from '../TsValue';

class Dashboard extends Component{
	
	static contextType = PsContext;
	
	constructor(props){
		super(props);
		this.state = {
			count: [],
			showLoader: false,
		}
		
		this.handleBtnClick = this.handleBtnClick.bind(this);
	}
	
	componentDidMount(){
		
		
	}
	
	handleBtnClick(){
		try{
			
			if(!window.confirm('Do you want to send SMS?')){
				return;
			}
			
			this.setState({showLoader: true});
			
			axios.post(Api.Url+'v1/send_bulk_sms').then(res=>{
				if(res['data'].status=='1'){
					alert('SMS Send Successfully.!');
					this.setState({showLoader: false});
				}
				else{
					alert(res['data'].message);
					this.setState({showLoader: false});
				}
			});
		}
		catch(er){
			alert('Unexpected Error');
			this.setState({showLoader: false});
		}
	}
	
	render(){

		return(
			<div className="container" >
				<Spin spinning={this.state.showLoader} >
				
				<TsValue />
				
				<Row className="mt-30" >
					<Col md={12} >
						<Card>
							<Card.Body>
								<p>
									When you click SEND SMS TO CUSTOMERS button it will take some time to send to all the customers.
								</p>
								<Button size="sm" variant="dark" onClick={this.handleBtnClick}  >
									SEND SMS TO CUSTOMERS
								</Button>
							</Card.Body>
						</Card>
					</Col>
				</Row>
			
			
				</Spin>
				
			</div>
		);
	}
	
}
export default Dashboard;
